export function getCustomModalContentStyle(classNameContent) {
  const c = classNameContent || ''
  if (c.includes('banners-section__modal-content')) {
    return {
      overflow: 'auto',
      padding: 0,
      maxHeight: 'none',
      flex: '1 1 auto',
      minHeight: 0,
    }
  }
  if (c.includes('scfo-modal-form-body')) {
    // Cuerpo de formulario con scroll interno: el footer (acciones) queda
    // siempre fijo y visible aunque la vista previa sea alta.
    return {
      overflow: 'auto',
      flex: '1 1 auto',
      minHeight: 0,
    }
  }
  return {
    overflow: 'visible',
  }
}
